import { render, staticRenderFns } from "./ThermalEnergyIcon.vue?vue&type=template&id=b32d0f98&"
import script from "./ThermalEnergyIcon.vue?vue&type=script&lang=js&"
export * from "./ThermalEnergyIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports